import { makeStyles } from "@material-ui/styles";

const teamSummaryStyles = makeStyles((theme) => ({
	container: {
		"& p": {
			color: theme.palette.gameMode.primary
		},
		[theme.breakpoints.only("xs")]: {
			justifyContent: "center"
		}
	},

	logo: {
		width: "3.9vw",
		height: "3.9vw",
		minHeight: 50,
		minWidth: 50,
		"& img": {
			objectFit: "contain"
		}
	},
	avatar: {
		width: theme.spacing(7),
		height: theme.spacing(7),
		fontWeight: "bold",
		color: theme.palette.menu.backgroundColor
	},
	teamNameContainer: {
		marginTop: 12,
		padding: theme.spacing(0, 2)
	},
	teamNameText: {
		fontWeight: "bold",
		fontSize: 20,
		fontFamily: "Overpass",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		"&.small": {
			fontSize: 16
		},
		[theme.breakpoints.only("xs")]: {
			display: "none"
		}
	},
	reversed: {
		textAlign: "end"
	},
	scoreText: {
		fontWeight: "500",
		fontFamily: "Barlow Condensed",
		fontSize: 56,
		"&.small": {
			fontSize: 36
		}
	}
}));

export default teamSummaryStyles;
